import axios from "@/axios"
import { useStore } from "vuex"
import { ref, computed } from "vue"
import useApp from "./useApp"

const useNotifications = () => {

    const { ToastMsgInfo, ToastMsgError } = useApp();
    const store = useStore()
    let axiosHeaders = {
        headers: {
            token: store.state.auth.token,
        }
    }

    const data = ref({})

    const changePage = (npage) => {
        if (npage > 0 && npage <= data.value.totalPages && data.value.currentPage != npage) {
            getNotifications(npage);
        }
    }

    const getNotifications = async (page = 1) => {
        axiosHeaders.params = { page }
        try {
            const res = await axios.get("/notifications", axiosHeaders)
            if (res.data.status == "success") {
                data.value = res.data
                return data
            } else {
                return false
            }

        } catch (err) {
            console.log(err)
            return false
        }

    } //Cierre Funcion 


    const pages = computed(() => {
        {
            // Determinar el rango de páginas a mostrar
            let start = Math.max(1, data.value.currentPage - 5);
            let end = Math.min(data.value.totalPages, data.value.currentPage + 4);

            // Ajustar si estamos al principio o al final
            if (data.value.currentPage <= 5) {
                end = Math.min(10, data.value.totalPages);
            } else if (data.value.currentPage + 4 >= data.value.totalPages) {
                start = Math.max(1, data.value.totalPages - 9);
            }

            // Crear un array con el rango de números
            const pages = [];
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        }
    })

    const identifyCondition = (notif) => {
        let condition = "No Asignado";
        if (notif.condition == "=") {
            condition = "Igual a";
        }
        if (notif.condition == ">") {
            condition = "Mayor que";
        }
        if (notif.condition == ">=") {
            condition = "Mayor o Igual a";
        }
        if (notif.condition == "<") {
            condition = "Menor que";
        }
        if (notif.condition == "<=") {
            condition = "Menor o Igual a";
        }
        if (notif.condition == "!=") {
            condition = "Distinto a";
        }
        if (notif.condition == "connected") {
            condition = "Conectado";
        }
        if (notif.condition == "disconnected") {
            condition = "Desconectado";
        }

        return condition;
    };


    const deleteNotif = async (id) => {
        axiosHeaders.params = { id }
        try {
            const res = await axios.delete("/notifications", axiosHeaders)
            if (res.data.status == "success") {
                ToastMsgInfo("Notificacion Borrada", "bell", 5000);
                store.dispatch("getNotifications")
                getNotifications(data.value.currentPage)
            }

        } catch (err) {
            console.log()
            if (err.request.status == 403){
                ToastMsgError('No Autorizado !', "server", 3000);    
                return 
            }
            ToastMsgError("Error en Solicitud al Servidor", "server", 3000);
        }
    }; //Cierre DeleteNotif

    const notificationReaded = async (notifId, status = true) => {
        const toSend = {
            notifId: notifId,
            status
        }
        try {
            const res = await axios.put("/notifications",toSend,axiosHeaders)
            if (res.data.status == "success") {
                await getNotifications(data.value.currentPage)
                store.dispatch("getNotifications");
            }


        } catch (err) { 
            console.log(err)
        }

    }

    return {
        getNotifications,
        data,
        changePage,
        pages,
        identifyCondition,
        deleteNotif,
        notificationReaded
    }

}

export default useNotifications